import { observable } from "@legendapp/state";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { synced } from "@legendapp/state/sync";

export const datasetPage$ = observable({
  /** The dataset ID currently displayed in the studio, synced from the route param. Null when not on a dataset page. */
  activeDatasetId: "",
  studio: synced({
    initial: {
      leftPaneOpen: true,
      bottomPaneOpen: false,
      bottomPaneTab: "table" as "table" | "data",
    },
    persist: {
      name: "data-studio",
      plugin: ObservablePersistLocalStorage,
    },
  }),
});

export const toggleLeftPane = () => datasetPage$.studio.leftPaneOpen.toggle();
export const toggleBottomPane = () =>
  datasetPage$.studio.bottomPaneOpen.toggle();
